import React from 'react';
import UpdateRequests from './update-requests'

export default class UpdateRequestComponent extends React.Component<{}, {}> {
    render() {
        return (
            <UpdateRequests />
        )
    }
}